// extracted by mini-css-extract-plugin
export default {"startButton":"Footer_startButton__oBRab","pauseButton":"Footer_pauseButton__6wAON","buttonBg":"Footer_buttonBg__uGFZU"};